<template>
  <div>
    <div v-for="(item, idx) in items" :key="idx">
      <ShipmentPrototypeItem
        :visible="item.flag"
        :expanded="false"
        :key="item.id"
        :id="item.id"
        @delete="removeItem"
      >
        <template v-slot:title>
          <b-input-group>
            <b-form-input
              aria-label="Type"
              placeholder="Type"
              class="text-center col-5"
              v-model="item.packageType"
            ></b-form-input>
            <b-form-input
              aria-label="Description"
              placeholder="Description"
              class="text-center"
              v-model="item.description"
            ></b-form-input>
          </b-input-group>
        </template>
        <template v-slot:body>
          <b-form-row class="justify-content-center">
            <b-col cols="4">
              <b-input-group class="mb-2">
                <b-form-input
                  aria-label="Weight"
                  placeholder="Weight"
                  class="text-center"
                  v-model="item.weight"
                  type="number"
                  step="0.01"
                  min="0.0"
                  number
                ></b-form-input>
                <b-form-select
                  class="col-3"
                  v-model="item.selectedWeightType"
                  :options="item.optionsWeightType"
                ></b-form-select>
              </b-input-group>
            </b-col>
            <b-col cols="4">
              <b-input-group class="mb-2">
                <b-form-input
                  aria-label="Volume"
                  placeholder="Volume"
                  class="text-center"
                  v-model="item.volume"
                  type="number"
                  number
                  step="0.01"
                  min="0.0"
                ></b-form-input>
                <b-form-select
                  class="col-3"
                  v-model="item.selectedVolumeType"
                  :options="item.optionsVolumeType"
                ></b-form-select>
              </b-input-group>
            </b-col>
          </b-form-row>
          <b-form-row class="justify-content-center">
            <b-col>
              <b-form-input
                v-model="item.length"
                type="number"
                number
                step="0.01"
                min="0.0"
                aria-label="Length"
                placeholder="Length"
                class="text-center"
              ></b-form-input>
            </b-col>
            <b-col cols="auto" class="d-flex align-items-center">
              <b-icon-x></b-icon-x>
            </b-col>
            <b-col>
              <b-form-input
                v-model="item.width"
                type="number"
                number
                step="0.01"
                min="0.0"
                aria-label="Width"
                placeholder="Width"
                class="text-center"
              ></b-form-input>
            </b-col>
            <b-col cols="auto" class="d-flex align-items-center">
              <b-icon-x></b-icon-x>
            </b-col>
            <b-col>
              <b-form-input
                v-model="item.height"
                number
                type="number"
                step="0.01"
                min="0.0"
                aria-label="Height"
                placeholder="Height"
                class="text-center"
              ></b-form-input>
            </b-col>
            <b-col cols="auto">
              <b-form-select
                v-model="item.selectedMeasureType"
                :options="item.optionsMeasureType"
              ></b-form-select>
            </b-col>
            <!--                <div class="col-2">-->
            <!--                  <label>-->
            <!--                    <select class="selectpicker" data-width="fit">-->
            <!--                      <option>in</option>-->
            <!--                      <option>m</option>-->
            <!--                    </select>-->
            <!--                  </label>-->
            <!--                </div>-->
          </b-form-row>
          <b-form-row class="justify-content-center mt-2">
            <b-col>
              <b-form-input
                v-model="item.seal"
                aria-label="Seal"
                placeholder="Seal"
                class="text-center"
              ></b-form-input>
            </b-col>
            <b-col cols="auto" class="d-inline-flex align-items-center">
              <ToggleSwitch
                :active="item.hazardous"
                @toggle="toggleHazardous(item.id)"
                class="pl-2"
              ></ToggleSwitch>
              <label class="form-check-label ml-2">
                Hazardous?
              </label>
            </b-col>
          </b-form-row>
        </template>
      </ShipmentPrototypeItem>
    </div>
    <hr class="my-0">
    <b-button
      variant="outline-dark"
      class="mt-3 text-xs"
      @click="addNewItem()"
    >
      Add Item
    </b-button>
  </div>
</template>

<script>
import ShipmentPrototypeItem from './ShipmentPrototypeItem.vue';
import ToggleSwitch from './ToggleSwitch.vue';

export default {
  name: 'ShipmentPrototypeList',
  props: ['items'],
  methods: {
    removeItem(id) {
      this.$emit('remove', id);
    },
    addNewItem() {
      this.$emit('add');
    },
    toggleHazardous(idx) {
      this.$emit('toggleHazard', idx);
    },
  },
  components: { ShipmentPrototypeItem, ToggleSwitch },
};
</script>

<style scoped>

</style>
